(ns frontend.test.tiptap-mention
  (:require
   [reagent.core :as r]
   [common.schema.entities.survey.survey-text-variables :as survey-vars]
   [ui.components.tiptap.view :as mention-tiptap]))

(defn output-inspector [label text-atom html-atom json-atom]
  [:div.mt-2.space-y-1
   [:h4.font-semibold.text-sm label]
   [:div.grid.grid-cols-3.gap-2
    [:div
     [:span.text-xs.text-gray-500 "text"]
     [:pre.bg-gray-100.p-2.rounded.text-xs.overflow-auto
      {:style {:max-height "100px"}}
      (or @text-atom "")]]
    [:div
     [:span.text-xs.text-gray-500 "html"]
     [:pre.bg-gray-100.p-2.rounded.text-xs.overflow-auto
      {:style {:max-height "100px"}}
      (or @html-atom "")]]
    [:div
     [:span.text-xs.text-gray-500 "json"]
     [:pre.bg-gray-100.p-2.rounded.text-xs.overflow-auto
      {:style {:max-height "100px"}}
      (pr-str @json-atom)]]]])

(defn test-basic-mention []
  (let [text* (r/atom nil)
        html* (r/atom nil)
        json* (r/atom nil)]
    (fn []
      [:section.flex.flex-col.gap-2
       [:h3.text-lg.font-semibold "1. Basic mention editor"]
       [:p.text-sm.text-gray-600
        "Trigger char " [:code "{"] " with all survey variables. Type " [:code "{"] " to open suggestion dropdown."]
       [mention-tiptap/view
        {:trigger-char "{"
         :item-texts   survey-vars/variable-ids
         :value        ""
         :on-change    (fn [text html json]
                         (reset! text* text)
                         (reset! html* html)
                         (reset! json* json))
         :class        "max-w-2xl"}]
       [output-inspector "on-change output:" text* html* json*]])))

(defn test-prepopulated []
  (let [text* (r/atom nil)
        html* (r/atom nil)
        json* (r/atom nil)]
    (fn []
      [:section.flex.flex-col.gap-2
       [:h3.text-lg.font-semibold "2. Pre-populated content"]
       [:p.text-sm.text-gray-600
        "Editor initialized with mentions already in the HTML. Verify mention nodes render as pills."]
       [mention-tiptap/view
        {:trigger-char "{"
         :item-texts   survey-vars/variable-ids
         :value        "<p>Dear <span data-type=\"mention\" class=\"mention\" data-id=\"target\" data-mention-suggestion-char=\"{\">target</span>, please complete your survey by <span data-type=\"mention\" class=\"mention\" data-id=\"reference_date\" data-mention-suggestion-char=\"{\">reference_date</span>.</p>"
         :on-change    (fn [text html json]
                         (reset! text* text)
                         (reset! html* html)
                         (reset! json* json))
         :class        "max-w-2xl"}]
       [output-inspector "on-change output:" text* html* json*]])))

(defn test-custom-trigger []
  (let [text* (r/atom nil)
        html* (r/atom nil)
        json* (r/atom nil)]
    (fn []
      [:section.flex.flex-col.gap-2
       [:h3.text-lg.font-semibold "3. Custom trigger char"]
       [:p.text-sm.text-gray-600
        "Uses " [:code "@"] " as trigger instead of " [:code "{"] ". Type " [:code "@"] " to open suggestions."]
       [mention-tiptap/view
        {:trigger-char "@"
         :item-texts   survey-vars/variable-ids
         :value        ""
         :on-change    (fn [text html json]
                         (reset! text* text)
                         (reset! html* html)
                         (reset! json* json))
         :class        "max-w-2xl"}]
       [output-inspector "on-change output:" text* html* json*]])))

(defn test-empty-items []
  [:section.flex.flex-col.gap-2
   [:h3.text-lg.font-semibold "4. Empty item-texts"]
   [:p.text-sm.text-gray-600
    "No variables provided. Typing " [:code "{"] " should show an empty or no dropdown."]
   [mention-tiptap/view
    {:trigger-char "{"
     :item-texts   []
     :value        ""
     :on-change    (fn [text html json]
                     (js/console.log "empty-items:" text))
     :class        "max-w-2xl"}]])

(defn test-styled []
  [:section.flex.flex-col.gap-2
   [:h3.text-lg.font-semibold "5. Custom styling"]
   [:p.text-sm.text-gray-600
    "Verify that the " [:code ":class"] " option passes through correctly."]
   [mention-tiptap/view
    {:trigger-char "{"
     :item-texts   survey-vars/variable-ids
     :value        "<p>Styled editor</p>"
     :on-change    (fn [text html json]
                     (js/console.log "styled:" text))
     :class        "max-w-2xl border-2 border-blue-500 rounded-lg"}]])

(defn test-many-variables []
  (let [many-vars (into survey-vars/variable-ids
                        ["custom_field_1" "custom_field_2" "company_name"
                         "fund_name" "reporting_date" "sender_name"
                         "sender_email" "due_date" "survey_title"])]
    [:section.flex.flex-col.gap-2
     [:h3.text-lg.font-semibold "6. Many variables + filtering"]
     [:p.text-sm.text-gray-600
      "14 variables. Type " [:code "{re"] " to verify filtering narrows to "
      [:code "reference_date"] " and " [:code "reference_period"] " and " [:code "reporting_date"] "."]
     [mention-tiptap/view
      {:trigger-char "{"
       :item-texts   many-vars
       :value        ""
       :on-change    (fn [text html json]
                       (js/console.log "many-vars:" text))
       :class        "max-w-2xl"}]]))

(defn view []
  [:div.flex.flex-col.gap-8.p-4
   [:h2.text-xl.font-bold "Tiptap Mention Editor Tests"]
   [:p.text-sm.text-gray-600
    "Tests for " [:code "ui.components.tiptap.view"] " — the mention/variable-aware editor for survey templates."]
   [test-basic-mention]
   [test-prepopulated]
   [test-custom-trigger]
   [test-empty-items]
   [test-styled]
   [test-many-variables]])
